/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-13 01:57:36 
 * @Last Modified by:   zhengxiaowen 
 * @Last Modified time: 2018-10-13 01:57:36 
 */
import api from './api'
import fetch from './fetch'
import router from './router'

export {
    api,
    fetch,
    router,
}


// WEBPACK FOOTER //
// ./src/page/devDemo2/config/index.js